import React, { useEffect, useState } from "react";
import { Fragment } from "react";
import { Col, FormGroup, Input, Label, Nav, NavItem, NavLink, Row, TabContent, TabPane } from "reactstrap";
import classnames from 'classnames'; // Import classnames for conditional classes
import "./Profile.css";
import { getStaffsById, updateDefaultOrg, updateDefaultRole, updateMyProfile, updateProfilePhoto, updateDefaultOrgDetails, getUserProfile } from "../../../api/User";
import { failed, success } from "../../../utils/Tostify";
import { useDispatch, useSelector } from "react-redux";
import { decryptData } from "../../../utils/helper";
import moment from "moment";
import { useConfirmDialog } from "../../../hooks/useConfirmDialog";
import { handleFileUpload } from "../../../utils/ImageToBase64";
import Loader from "../../../components/Loader/Loader";
import { useNavigate } from "react-router";
import { changePassword, signIn } from "../../../api/auth";
import { userActions } from "../../../context/reducers/user";
import momentTimezone from "moment-timezone";
import { platformLayout } from "../../../utils/constants";
import { OrganizationEmailNotification, PlatformEmailNotification } from "./Constant";
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { resetBreadcrumb } from "../../../context/reducers/breadcrump";
import noProfileImg from "../../../../src/assets/images/noImage.jpg";


function Profile({ assignedUserList }) {
	const [activeTab, setActiveTab] = useState("1"); // Define activeTab in state
	const [selectedImage, setSelectedImage] = useState(null); // State for selected image file
	let user = useSelector(state => state.userReducer.user);
    let token = useSelector(state => state.userReducer.token);
	let roleDetails = localStorage.getItem("userRole");
	let roleId = localStorage.getItem("roleId");
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();
    const { getConfirmation } = useConfirmDialog();
	const [selectedOrg, setSelectedOrg] = useState(user?.defaultLogInOrg || '');
	const [selectedRole, setSelectedRole] = useState(user?.defaultRole?.value?._id || '');
	const [selectedHospital, setSelectedHospital] = useState('');
    const [clinics, setClinics] = useState([]);
	const [userDetails, setUser] = useState(user);
    const navigate = useNavigate();
	const [smsNotification, setSmsNotification] = useState(false);
	const [passwords, setPasswords] = useState({
		oldPassword: '',
		newPassword: '',
		confirmPassword: ''
	});
	const [error, setError] = useState('');
	const [notifications, setNotifications] = useState({
		applicationUpdate: false,
		newTask: false,
		loginRequest: false,
		newMessage: false,
		meetingUpdate: false,
		newAssignment: false,
		supportTicketUpdate: false,
		accessUpdate: false,
		workflowUpdate: false
	});
	const timezones = momentTimezone.tz.names().map((zone) => ({
		value: zone,
		label: `(GMT${momentTimezone.tz(zone).format("Z")}) ${zone}`
	}));

	const [selectedTimezone, setSelectedTimezone] = useState(null);
    const [switchRole, setSwitchRole]= useState();
	const [switchOrg, 	setSwitchOrg]= useState();
    const handleImageChange = async(e) => {
		if (e.target.files && e.target.files[0]) {
      const confirmed = await getConfirmation({
        title: "Attention!",
        actionBtnTitle: "Yes",
        message : `Are you sure want to update the profile photo ?`
      });
      if (confirmed) {
        setSelectedImage(URL.createObjectURL(e.target.files[0]));
        let res;
        try {
          setIsLoading(true);
          const values = {
            profilePhoto : e.target.files[0]
          };
          let base64OrgLogo = "";
          if (values?.profilePhoto) {
              base64OrgLogo = await handleFileUpload(values?.profilePhoto);
          }
          const fileExtension = values?.profilePhoto?.type?.split("/")[1];
          const ProfilePhotoURL = {
              base64String: base64OrgLogo,
              extension: fileExtension, // Add the file extension to the object
              name: values?.profilePhoto.name
          };
          values.profilePhoto = ProfilePhotoURL;
          res = await updateProfilePhoto({ values, dispatch, token, userId: user?._id });
          if (res?.status == "SUCCESS") {
              await getUser();
              setIsLoading(false);
              success(res?.message);
          }else{
              failed(res.data.message);
              setIsLoading(false);
          }
      } catch (error) {
          setIsLoading(false);
          failed(res?.message);
      }
      }
		}
	};

	const getUser = async () => {
        let res;
        try {
            setIsLoading(true);
			const values = {userId: user?._id };
            res = await getUserProfile({ dispatch, token, values });
            const responseData = res?.data;
            if (res?.status === "SUCCESS") {
				dispatch(userActions.loginSuccess({...responseData,accessToken: token}));
                setUser(responseData);
				setSmsNotification(responseData?.smsNotification);
				setNotifications(responseData?.emailNotifications);
				setSelectedTimezone(responseData?.timezone);
				setSelectedRole(responseData?.defaultRole?.value?._id);
				const roleDetails = roleId ? roleId : user?.defaultRole?.value?._id;
				const selectedRole = responseData?.roles?.find(
					(role) => role.value?._id === roleDetails
				);
				if (selectedRole.value?.active) {
					setSwitchRole({ roleId: selectedRole.value, roleName: selectedRole.label });
				}
				setSwitchOrg(localStorage.getItem("currentOrgId"));
                setIsLoading(false);
            }
        } catch (error) {
            failed(res?.message);
            setIsLoading(false);
        }
    };

	const setDefaultHospital = (orgId) => {
        const selectedOrganization = user.organizations.find(org => org?.organizationId?._id === orgId);
        if (selectedOrganization && selectedOrganization.defaultClinic) {
            const defaultClinic = selectedOrganization.defaultClinic._id;
            setSelectedHospital(defaultClinic || '');
            setClinics(selectedOrganization.clinicId);
        } else {
            setClinics([]);
            setSelectedHospital('');
        }
    };

	useEffect(()=>{
		getUser();
		console.log(user);
	},[]);

	const toggle = (tab) => {
		if (activeTab !== tab) setActiveTab(tab);
	};
	const handleOrgChange = (e) => {
        const orgId = e.target.value;
        setSelectedOrg(orgId);

        const selectedOrganization = userDetails.organizations.find(org => org?.organizationId?._id === orgId);
        if (selectedOrganization) {
            setClinics(selectedOrganization.clinics || []);
            setSelectedHospital(selectedOrganization.defaultClinic?._id || ''); // Set the first clinic as default
        } else {
            setClinics([]);
            setSelectedHospital(''); // Reset if no clinics are available
        }
    };

    // Handle role change
    const handleRoleChange = (e) => {
        setSelectedRole(e.target.value);
    };

    // Handle hospital change
    const handleHospitalChange = (e) => {
        setSelectedHospital(e.target.value);
    };

	const handleSave = () => {
        // Implement save logic here, e.g., send the selected values to the server
    };

	useEffect(() => {
        // Set default hospital when component mounts or when organization changes
        if (selectedOrg) {
            setDefaultHospital(selectedOrg);
        }
    }, [selectedOrg]);

	const handleUpdate = async(payload) => {
	let res;
	try {
		const confirmed = await getConfirmation({
			title: "Attention!",
			actionBtnTitle: "Yes",
			message : `Are you sure want to update profile?`
		});
		if (confirmed) {
		setIsLoading(true);
		res = await updateMyProfile({ values : payload, dispatch, token, userId: user?._id });
		if (res?.status == "SUCCESS") {
		setIsLoading(false);
		success(res?.message);
		getUser();
		} else {
		setIsLoading(false);
		failed(res?.message);
		}
		}
	} catch (error) {
		setIsLoading(false);
		failed(res?.message);
	}
	};

	const handleToggleChange = async () => {
		let res;
		try {
			const confirmed = await getConfirmation({
				title: "Attention!",
				actionBtnTitle: "Yes",
				message: `Are you sure you want to update your profile?`
			});

			if (confirmed) {
				const updatedNotification = !smsNotification;
				setSmsNotification(updatedNotification);
				setIsLoading(true);
				res = await updateMyProfile({ values : { smsNotification: updatedNotification }, dispatch, token, userId: user?._id });
				if (res?.status == "SUCCESS") {
				setIsLoading(false);
				success(res?.message);
				getUser();
				} else {
				setIsLoading(false);
				failed(res?.message);
				}
			}
		} catch (error) {
			console.error("Error confirming action:", error);
		}
	};

	const handleToggle = async (key) => {
		try {
		// Ask for confirmation
		const confirmed = await getConfirmation({
			title: "Attention!",
			actionBtnTitle: "Yes",
			message: `Are you sure you want to update your profile?`
		});

		if (confirmed) {
			// Proceed with the toggle update only after confirmation
			const updatedNotifications = { ...notifications, [key]: !notifications[key] };
			setIsLoading(true);

			// Call API to update profile
			const res = await updateMyProfile({
			values: { emailNotifications: updatedNotifications },
			dispatch,
			token,
			userId: user?._id
			});

			if (res?.status === "SUCCESS") {
			// setNotifications(updatedNotifications); // Update the toggle state
			success(res?.message);
			getUser(); // Refresh user data
			} else {
			failed(res?.message);
			}
		}
		} catch (error) {
		console.error("Error during confirmation or toggle update:", error);
		} finally {
		setIsLoading(false);
		}
	};

	const handleChange = (e) => {
		const { name, value } = e.target;
		setPasswords((prev) => ({ ...prev, [name]: value }));
		setError(''); // Clear errors on input change
	};

	const handleUpdatePassword = async (e) => {
		e.preventDefault();

		if (passwords.newPassword !== passwords.confirmPassword) {
			setError('New password and confirm password do not match.');
			return;
		}
		let res;
		try {
			setIsLoading(true);
			res = await changePassword({ values : { oldPassword: passwords.oldPassword, newPassword: passwords.newPassword }, dispatch, token });
			if (res?.status == "SUCCESS") {
			setIsLoading(false);
			success(res?.message);
			setPasswords({ oldPassword: '', newPassword: '', confirmPassword: '' });
			getUser();
			} else {
			setIsLoading(false);
			failed(res?.message);
			}
		} catch (err) {
			console.error("Error confirming action:", error);
		}
	};

	const handleTimezoneChange = (e) => {
		const selectedValue = e.target.value;
		const selectedOption = timezones.find((tz) => tz.value === selectedValue);
		if (selectedOption) {
			handleUpdate({ timezone: selectedOption.value });
		}
	};

	const handleSwitchRole = async () => {
		try {
			if (!user?.organizations || user.organizations.length === 0) {
				console.error("No organization has access.");
				failed("No organization has access.");
				return;
			}
			// Find the selected organization
			const selectedOrganization = user?.organizations?.find(
				(org) => String(org.organizationId?._id) === String(localStorage.getItem('currentOrgId') ? localStorage.getItem('currentOrgId') :user.defaultLogInOrg)
			);
			if (!selectedOrganization) {
				failed("Default organization not found.");
				return;
			}
			// Check if the organization is active and not deleted
			if (!selectedOrganization.organizationId.active || selectedOrganization.isDeleted) {
				failed("Default organization is inactive or deleted.");
				return;
			}
			// Check if clinics exist
			if (!selectedOrganization.clinicId || selectedOrganization.clinicId.length === 0) {
				failed("No clinics assigned to the default organization.");
				return;
			}
			// Check if the default clinic is set
			if (!selectedOrganization.defaultClinic) {
				failed("Default clinic is not set for the default organization.");
				return;
			}
			// Validate default clinic status
			if (!selectedOrganization.defaultClinic.active || selectedOrganization.defaultClinic.archived) {
				failed("Default clinic is inactive or deleted.");
				return;
			}
			// If all conditions pass, proceed with role switching
			setIsLoading(true);
			localStorage.setItem("userRole", switchRole.roleId?.portalLayout);
			localStorage.setItem("roleId", switchRole.roleId?._id);
			localStorage.setItem("currentHospitalId",selectedOrganization?.defaultClinic?._id);
			window.location.reload();
			setIsLoading(false);
		} catch (error) {
			console.error("Error switching role:", error);
			failed("An error occurred while switching roles.");
			setIsLoading(false);
		}
	};

	const handleSwitchOrg = async()=>{
		let res;
		try {
			setIsLoading(true);
				const orgWithDefaultClinic = userDetails?.organizations?.find(
					org =>
					org?.organizationId?._id == switchOrg
				);
				localStorage.setItem("currentHospitalId", orgWithDefaultClinic?.defaultClinic?._id);
				localStorage.setItem("currentOrgId", switchOrg);
				setIsLoading(false);
				window.location.reload();
		} catch (error) {
			failed(res?.message);
			setIsLoading(false);
		}
	};

	const handleDefaultUpdate = async(payload) => {
		let res;
		try {
			const selectedRoleDetails = user?.roles?.find(
                (role) => role.value._id === selectedRole
            );
			if(platformLayout.Organization === selectedRoleDetails.value.portalLayout){
				const selectedOrganization = user?.organizations?.find(
					(org) => org.organizationId._id === payload.orgId
				);
				if (!selectedOrganization?.defaultClinic) {
					failed("Default clinic is not set for the selected organization.");
					return;
				}
			}
			const confirmed = await getConfirmation({
				title: "Attention!",
				actionBtnTitle: "Yes",
				message : `Are you sure want to update profile?`
			});
			if (confirmed) {
			setIsLoading(true);
			const updatePayload = {
                ...payload,
                defaultRole: {
                    label: selectedRoleDetails.label,
                    value: selectedRoleDetails.value._id
                }
            };
			res = await updateDefaultOrgDetails({ values : updatePayload, dispatch, token, userId: user?._id });
			if (res?.status == "SUCCESS") {
			setIsLoading(false);
			success(res?.message);
			getUser();
			} else {
			setIsLoading(false);
			failed(res?.message);
			}
			}
		} catch (error) {
			setIsLoading(false);
			failed(res?.message);
		}
		};

	const notificationsList = roleDetails === platformLayout.Organization ? OrganizationEmailNotification : PlatformEmailNotification;

	const handleClick = (event, path) => {
		event.preventDefault();
		navigate(path);
	};

	const breadcrumbs = [
		<Link
			underline="hover"
			key="1"
			color="inherit"
			href="/app/home"
			onClick={(e) => handleClick(e, '/app/home')}
			sx={{ fontSize: '1.4rem' }}
		>
			Dashboard
		</Link>,
		<Typography key="2"  sx={{ color: 'text.primary', fontSize: '1.4rem'}}
		>
			Profile
		</Typography>
	];
	return (
		<Fragment>
			{isLoading && <Loader />}
			{/* <Stack direction="row" justifyContent="flex-left" sx={{width: '100%',mb: 2,ml: 4}}>
                <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
                {breadcrumbs}
                </Breadcrumbs>
            </Stack> */}
			<div className='profile_container'>
				<div>
					<Nav tabs>
						<NavItem>
							<NavLink className={classnames({ active: activeTab === "1" })} onClick={() => toggle('1')}>
								My Profile
							</NavLink>
						</NavItem>
						<NavItem>
							<NavLink className={classnames({ active: activeTab === '2' })} onClick={() => toggle('2')}>
								Settings
							</NavLink>
						</NavItem>
					</Nav>
					<TabContent activeTab={activeTab}>
						<TabPane tabId="1">
							<Row>
								<Col sm="12">
									<div className='profile_block'>
										<div className='profile_main d-flex justify-content-between align-items-center flex-wrap gap-3'>
											<div className='profile_info flex-wrap'>
												{/* <img src={} alt="img_profile" className="img_profile_one" /> */}
												{/* Image Upload and Preview */}
												<div className="img_block">
													{/* <div className="img_profile_container">
														{selectedImage ? (
															<img src={selectedImage} alt="Profile" className="img_profile_one" />
														) : (
															<img
																src={userDetails?.profilePhoto?.signedUrl}
																alt="Profile"
																className="img_profile_one"
															/>
														)}
													</div> */}
													<div className="img_profile_container">
													{selectedImage ? (
														<img src={selectedImage} alt="Profile" className="img_profile_one" />
													) : userDetails?.profilePhoto?.signedUrl ? (
														<img src={userDetails.profilePhoto.signedUrl} alt="Profile" className="img_profile_one" />
													) : (
														<img src={noProfileImg} alt="No Profile" className="img_profile_one" />
													)}
													</div>
													<div className="edit_img">
														<i className='fas fa-pen'></i>
													</div>
													<input
														type="file"
														accept="image/*"
														onChange={handleImageChange}
														className="img_upload_input"
													/>
												</div>
												<div>
													<h6>{userDetails?.firstName + " " + userDetails?.lastName}</h6>
													<p>{userDetails?.email}</p>
												</div>
											</div>
											<button className='edit_profile' onClick={()=>navigate("/app/edit-profile",{state:{userDetails}})}>Edit Profile</button>
										</div>
										<div className='data_profile'>
											<div className="info_block">
												<h4>Personal Information</h4>
												<div className="row">
													<div className="col-lg-4 col-md-6 col-sm-12 space_profile">
														<p>Date Of Birth : <span>{userDetails?.dob && moment(userDetails.dob).isValid()
															? moment(userDetails.dob).format("MM-DD-YYYY")
															: ""}</span>
														</p>
													</div>
													<div className="col-lg-4 col-md-6 col-sm-12 space_profile">
														<p>Language : <span>{userDetails?.language?.join(", ")}</span></p>
													</div>
													<div className="col-lg-4 col-md-6 col-sm-12 space_two_profile">
														<p>Gender : <span>{userDetails?.gender}</span></p>
													</div>
												</div>
											</div>
											<div className="info_block mt-4 mb-4">
												<h4>Contact Information</h4>
												<div className="row mb-3">
													<div className="col-lg-4 col-md-6 col-sm-12 space_profile">
														<p>Address : <span>{userDetails?.address}</span></p>
													</div>
													<div className="col-lg-4 col-md-6 col-sm-12 space_profile">
														<p>Phone Number : <span>{userDetails?.primaryPhone}</span></p>
													</div>
													<div className="col-lg-4 col-md-6 col-sm-12 space_two_profile">
														<p>Country : <span>{userDetails?.country}</span></p>
													</div>
												</div>
												<div className="row mb-3">
													{/* <div className="col-lg-4 col-md-6 col-sm-12 space_profile">
														<p>Village : <span>Pennsylvania</span></p>
													</div> */}
													<div className="col-lg-4 col-md-6 col-sm-12 space_profile">
														<p>Region : <span>{userDetails?.state}</span></p>
													</div>
													<div className="col-lg-4 col-md-6 col-sm-12 space_two_profile">
														<p>City : <span>{userDetails?.city}</span></p>
													</div>
													<div className="col-lg-4 col-md-6 col-sm-12 space_profile">
														<p>Pincode : <span>{userDetails?.postalCode}</span></p>
													</div>
												</div>
												{/* <div className="row mb-3">

													<div className="col-lg-4 col-md-6 col-sm-12">
														<p>Time Zone : <span>(GMT-07:00) Pacific Time - Los Angeles</span></p>
													</div>
												</div> */}
											</div>
											<div className="info_block">
												<h4>About</h4>
												<p>{userDetails?.about}</p>
											</div>
										</div>
									</div>
								</Col>
							</Row>
						</TabPane>
						<TabPane tabId="2" className="profile_tab_two">
							<div className='profile_main_two'>
								<div className="table_space">
									<div className="table-responsive">
										<table>
											<thead>
												<tr className="header_table">
													<th>
														Email Notifications
													</th>
													<th>
														Actions
													</th>
												</tr>
											</thead>
											<tbody>
										{notificationsList?.map((item, index) => (
											<React.Fragment key={item.key}>
											<tr>
												<td colSpan={9} height={5} className="bg_light"></td>
											</tr>
											<tr className={index % 2 === 0 ? 'first_block' : 'second_block'}>
												<td>{item.label}</td>
												<td>
												<div className="toggle">
													<input
													type="checkbox"
													id={`checktoggle-${item.key}`}
													checked={notifications[item.key]}
													onChange={() => handleToggle(item.key)}
													/>
													<label htmlFor={`checktoggle-${item.key}`}></label>
												</div>
												</td>
											</tr>
											</React.Fragment>
										))}
										</tbody>
										</table>
									</div>
								</div>
							</div>
							<div className="profile_main_three">
								<div className="table-responsive">
									<table>
										<tbody>
											<tr>
												<td><h5>SMS Alerts</h5></td>
												<td className="">
													<div className="toggle">
														<input
															type="checkbox"
															id="smsNotification"
															checked={smsNotification}
															onChange={handleToggleChange}
														/>
														<label htmlFor="smsNotification"></label>
													</div>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
							<div className="profile_main_three org">
								<h5>Default Settings</h5>
								<p>Set default organization, hospital and role  as primary account for initial login.</p>
								<div className="d-flex justify-content-between mt-4 gap-5 form_block_org">
									{roleDetails === platformLayout.Organization && <div className="form_organization">
										<FormGroup>
											<Label for="organizationSelect">Default Organization</Label>
											<Input
												id="organizationSelect"
												name="select"
												type="select"
												value={selectedOrg}
												onChange={handleOrgChange}
											>
												{userDetails?.organizations
												.filter((org) => org.clinicId && org.clinicId.length > 0 && org.organizationId?.active && !org.isDeleted)
												.map((org) => (
													<option key={org?.organizationId?._id} value={org?.organizationId?._id}>
														{org?.organizationId?.name}
													</option>
												))}
											</Input>
										</FormGroup>
									</div>}
									<div className="form_organization">
										<FormGroup>
										<Label for="roleSelect">Default Role</Label>
										<Input
											id="roleSelect"
											name="select"
											type="select"
											value={selectedRole || ""}
											onChange={handleRoleChange}
										>
											<option>Select a role</option>
											{userDetails?.roles
											?.filter((role) => role?.value?.active === true)
											.sort((a, b) => a.value.roleName.localeCompare(b.value.roleName))
											.map((role) => (
												<option key={role.value._id} value={role.value._id}>
												{role.value.roleName}
												</option>
											))}
										</Input>
										</FormGroup>
									</div>
									{roleDetails === platformLayout.Organization &&<div className="form_organization">
										<FormGroup>
											<Label for="hospitalSelect">Default Hospital</Label>
											<Input
												id="hospitalSelect"
												name="select"
												type="select"
												value={selectedHospital}
												onChange={handleHospitalChange}
											>
												{clinics.filter((cli) => cli.active === true).map((clinic) => (
													<option key={clinic._id} value={clinic._id}>
														{clinic.name}
													</option>
												))}
											</Input>
										</FormGroup>
									</div>}
								</div>
								<div className="d-flex justify-content-center reset_blk">
									<button className="save-blk" onClick={()=>handleDefaultUpdate({hospitalId : selectedHospital, orgId:selectedOrg})}>Save</button>
								</div>
							</div>
							{roleDetails === platformLayout.Organization &&<div className="profile_main_three org">
								<h5>Switch Organization</h5>
								<p>Switch to different organization.</p>
								<div className="d-flex justify-content-between mt-4 gap-5 form_block_org">
									<div className="form_organization">
										<FormGroup>
											<Input
												id="exampleSelect"
												name="select"
												type="select"
												value={switchOrg}
												onChange={(e) => {
													setSwitchOrg(e.target.value);
												}}
											>
												{userDetails.organizations.filter((org) => org.clinicId && org.clinicId.length > 0 && org.organizationId?.active && !org.isDeleted).map((org) => (
													<option key={org?.organizationId?._id} value={org?.organizationId?._id}>
														{org?.organizationId?.name}
													</option>
												))}
											</Input>
										</FormGroup>
									</div>
									<div className="form_organization">
										<div className="d-flex justify-content-center reset_blk">
											<button className="save-blk" onClick={()=>handleSwitchOrg()}>Switch</button>
										</div>
									</div>
									<div className="form_organization">
									</div>
								</div>
							</div>}
							{userDetails?.roles?.filter(role => role?.value?.active === true)?.length > 1 ? (
							<div className="profile_main_three org">
								<h5>Switch Role</h5>
								<p>Switch to different role.</p>
								<div className="d-flex justify-content-between mt-4 gap-5 form_block_org">
								<div className="form_organization">
									<FormGroup>
									<Input
										id="exampleSelect"
										name="select"
										type="select"
										value={switchRole?.roleId?._id || ""}
										onChange={(e) => {
										const selectedRole = user?.roles?.find(
											(role) => role.value._id === e.target.value
										);
										if (selectedRole) {
											setSwitchRole({
											roleId: selectedRole.value,
											roleName: selectedRole.label
											});
											dispatch(resetBreadcrumb());
										}
										}}
									>
										<option>Select a role</option>
										{userDetails?.roles
										?.filter(role =>
											role?.value?.active === true
										)
										?.sort((a, b) =>
											a.value.roleName.localeCompare(b.value.roleName)
										)
										?.map((role) => (
											<option key={role.value._id} value={role.value._id}>
											{role.value.roleName}
											</option>
										))}
									</Input>
									</FormGroup>
								</div>
								<div className="form_organization">
									<div className="d-flex justify-content-center reset_blk">
									<button className="save-blk"
									disabled={switchRole?.roleId?._id === roleId}
									onClick={() => handleSwitchRole()}>
										Switch
									</button>
									</div>
								</div>
								<div className="form_organization">
								</div>
								</div>
							</div>
							) : null}
							<div className="profile_main_three org">
								<h5>Time Zone :</h5>
								<div className="d-flex justify-content-between mt-2 gap-5">
									<div className="form_organization">
										<FormGroup>
											<Label >
												Select Time Zone
											</Label>
											<Input
												id="timezoneSelect"
												name="timezone"
												type="select"
												value={selectedTimezone}
												onChange={handleTimezoneChange}
											>
												<option value="">Select a Timezone</option>
												{timezones.map((tz) => (
												<option key={tz.value} value={tz.value}>
													{tz.label}
												</option>
												))}
											</Input>
										</FormGroup>
									</div>
								</div>
							</div>
							<div className="profile_main_four">
								<h5>Password Management :</h5>
								<div className="d-flex justify-content-between mt-2 gap-5 form_block_org">
									{['Current Password', 'New Password', 'Confirm Password'].map((label, index) => {
									const field = ['oldPassword', 'newPassword', 'confirmPassword'][index];
									return (
										<div className="form_password" key={field}>
										<FormGroup>
											<Label for={field}>{label}</Label>
											<Input
											id={field}
											name={field}
											type="password"
											value={passwords[field]}
											onChange={handleChange}
											required
											/>
										</FormGroup>
										</div>
									);
									})}
								</div>
								{error && <p className="text-danger">{error}</p>}
								<div className="d-flex justify-content-center reset_blk">
									<button className="reset_block" onClick={(e)=>handleUpdatePassword(e)}>Update Password</button>
								</div>
							</div>
						</TabPane>
					</TabContent>
				</div>
			</div>
		</Fragment>
	);
}
export default Profile;
